import { ApplicationProduct } from "store/entities/applications/interfaces";

import { BaseApi } from "../base";

export interface IUninstallApplicationBody {
  reason?: string;
}

export default class ApplicationsApi extends BaseApi {
  protected readonly service = "dev-platform";
  protected readonly prefix = "applications";
  protected readonly version = 2;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchInstalledApps = () => this.get("installed", { product: ApplicationProduct.HelpDesk });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchPrivateApps = () => this.get("", { product: ApplicationProduct.HelpDesk });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchInReviewApps = () => this.get("reviewed", { product: ApplicationProduct.HelpDesk });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  install = (applicationId: string) => this.put(`${applicationId}/install`);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  uninstall = (applicationId: string, payload?: IUninstallApplicationBody) =>
    this.delete(`${applicationId}/install`, payload);
}
